<template>
  <div class="list_index">
    <el-row type="flex" :gutter="10">
      <el-col :span="1.5">
        <plainTitle :hasGoback="true"></plainTitle>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          class="yl-button"
          @click="addTemplate"
        >新增组态画面</el-button>
      </el-col>
    </el-row>
    <el-table stripe border :data="tableData" :row-style="{height: '0'}" :cell-style="{padding: '1px'}">
        <el-table-column label="组态画面名称" prop="templateName" align="center">
            <template slot-scope="scope">
                <el-button type="text" @click="editTemplate(scope.row)">{{scope.row.templateName}}</el-button>
            </template>
        </el-table-column>
        <!-- <el-table-column label="选择首页" align="center">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.isDefault" :disabled="scope.row.isDefault == 1?true:false" :active-value="1" :inactive-value="0" @change="isDefaultChange(scope.row)"></el-switch>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <!-- <el-button @click="edit(scope.row)">修改</el-button> -->
            <el-tooltip class="item" effect="dark" content="复制组态画面" placement="top">
              <el-button @click="copySubTemplate(scope.row)" type="text" icon="el-icon-fz" size="small"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top">
              <el-button type="text" icon="el-icon-sc" size="small" @click="del(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
    </el-table>
    <el-dialog title="复制组态画面" :visible.sync="DeviceTemplate" width="30%">
      <el-form :model="form" label-position="right" label-width=".8rem" ref="copyDeviceTemplate" :rules="rules">
        <el-form-item label="组态画面名称" prop="newTemplateName">
          <el-input type="text" class="yl-input_noIcon" size="small" placeholder="请输入组态画面名称" v-model="form.newTemplateName" ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="mini" class="yl-button2">取 消</el-button>
        <el-button type="primary" size="mini" class="yl-button" @click="submitForm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DeviceTemplateService from '@/api/deviceTemplate';
import plainTitle from "@/components/plain-title";
export default {
    components: {
      plainTitle,
    },
    data(){
        return{
          equipmentName:'',//设备名称
          oldTemplateName:'',//复制之前的模板名称
          DeviceTemplate:false,
          tableData:[],
          parentPageModel:'',
          form:{
            newTemplateName:''
          },
          rules:{
            newTemplateName:[{ required: true,message: '请输入组态画面名称', trigger: 'blur' }]
          }
        }
    },
    methods:{
      //获取模板列表
      getTemplateList(){
        DeviceTemplateService.getSubTemolate({
            user_id:this.$store.state.user_id,
            parentPageModel:this.parentPageModel
        }).then(res=>{
            this.tableData = res.data;
        }).catch(err=>{
            this.$message.error(err.message)
        })
      },
      //修改组态画面名称
      edit(val){

      },
      //复制模板
      copySubTemplate(val){
        this.form = {};
        this.oldTemplateName = val.templateName;
        this.DeviceTemplate = true;
      },
      //提交表单
      submitForm(){
      this.$refs.copyDeviceTemplate.validate((valid)=>{
        if(valid){
          DeviceTemplateService.copySubTemplate({
            user_id:this.$store.state.user_id,
            oldTemplateName:this.oldTemplateName,
            equipmentName:this.equipmentName,
            parentPageModel:this.parentPageModel,
            ...this.form,
            username:this.$store.state.username
          }).then(res=>{
            this.$message.success('复制成功');
            this.DeviceTemplate = false;
            this.getTemplateList();
          }).catch(err=>{
            this.$message.error(err.message)
          })
        }else{
          this.$message.error("请检查必填项");
          return false;
        }
        })
      },
      //删除组态画面
      del(val){
        let _this = this;
        this.$confirm('是否确认删除组态画面名称为"' + val.templateName + '"的数据项?', "警告", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function() {
            DeviceTemplateService.deleteSubTemolate({
              templateName:val.templateName,
              parentPageModel:_this.parentPageModel,
              equipmentName:_this.equipmentName,
              user_id:_this.$store.state.user_id,
              username:_this.$store.state.username
            }).then(res=>{
              if(res.code == 200){
                _this.$message.success('删除成功');
                _this.getTemplateList();
              }else{
                _this.$message.error(res.message)
              }
            }).catch(err=>{
              _this.$message.error(err.message)
            })
          })
      },
      //取消复制设备模板
      cancel(){
        this.DeviceTemplate = false;
        this.resetForm('copyDeviceTemplate');
      },
      //默认页面改变
      // isDefaultChange(val){
      //   DeviceTemplateService.defaultTemplate({
      //     user_id:this.$store.state.user_id,
      //     parentPageModel:this.parentPageModel,
      //     templateName:val.templateName
      //   }).then(res=>{
      //     this.getTemplateList();
      //   }).catch(err=>{
      //     this.$message.error(err.message)
      //   })
      // },
      //跳转新增模板页面
      addTemplate(){
        this.$router.push({
            path:'/addTemplate',
            query:{
              parentPageModel:this.parentPageModel,
              equipmentName:this.equipmentName
            }
        })
      },
      //跳转修改模板页面
      editTemplate(val){
        this.$router.push({
          path:'/addTemplate',
          query:{
            parentPageModel:this.parentPageModel,
            templateName:val.templateName,
            equipmentName:this.equipmentName
          }
        })
      }
    },
    mounted(){
      if(this.$route.query.parentPageModel){
        this.parentPageModel = this.$route.query.parentPageModel;
        this.equipmentName = this.$route.query.equipmentName;
      }
      this.getTemplateList()
    }
}
</script>

<style lang="scss" scoped>
.item{
  margin:0 10px;
  margin-bottom: 3px;
}
</style>